import React, { useEffect, useState } from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { CharAndLoading, Container, Spin } from './chart.styles'
import { MonthCalendar } from './month-calendar'

interface Props
  extends Readonly<{
    updateChart(values: any): Promise<{}>
    isLoading: boolean
  }> {}

export function Chart(props: Props) {
  const [monthFilter, setMonthFilter] = useState<string>()
  const [data, setData] = useState({})

  async function update(monthFilter: string) {
    setData(await props.updateChart(monthFilter))
  }

  useEffect(() => {
    update(monthFilter)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [monthFilter])

  return (
    <Container>
      <MonthCalendar setMonthFilter={setMonthFilter} />
      <CharAndLoading>
        {props.isLoading && <Spin size="large" />}
        <HighchartsReact highcharts={Highcharts} immutable options={data} />
      </CharAndLoading>
    </Container>
  )
}
